import Repo from './Base';
import authService from '../components/api-authorization/AuthorizeService';

const resource = '/videos';

export default {

  async getOtp(id, { signal } = {}) {
    const token = await authService.getAccessToken();
    let result = await Repo.post(
      `${resource}/${id}/otp`, "",
      { signal, timeout: 20000, headers: !token ? {} : { 'Authorization': `Bearer ${token}` } });
    if (result.status === 200) {
      let data = result.data;
      const otpdata = JSON.parse(data.otp);
      let retval = { otp: otpdata.otp, vid: data.id, playbackInfo: otpdata.playbackInfo };
      return retval;
    } else {
      throw result;
    }
  },

  // Helper to send video action logs to the backend
  async sendVideoAction(video_id, action_id, class_id) {
    const token = await authService.getAccessToken();
    const response = await fetch(`videos/${video_id}/actions/${action_id}?class=${class_id}`, {
      method: 'POST',
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
    });

    // If response is not 200 OK, throw an error with status and response
    if (response.status !== 200) {
      const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
      error.status = response.status;
      error.statusText = response.statusText;
      error.response = response;
      throw error;
    }

    return response;
  },

};


